export default __webpack_public_path__ + "static/media/rocket.220795d6.svg";